import Icon from '@douyinfe/semi-icons';
export default Icon;